const getters = {
	monitoringElements: (state) =>
	{
		if (state.menu && state.menu.length > 0)
		{
			return state.menu;
		}
		return null;
	},
};
export default { getters };
